/**
 * The selected map depot stop state
 */
export type SelectedMapDepotStopState = string | null;

export const defaultSelectedMapDepotStopState: SelectedMapDepotStopState = null;
